import '../styles/main.scss';
import initFeed from './feed';
import Calendar from './calendar';
import startVideoPlayer from './videoPlayer';

(($) => {
  $(document).ready(() => {
    const analyticsUA = { // eslint-disable-line
      ge: 'UA-296593-9',
      sportv: 'UA-16233545-1',
    };

    const calendar = new Calendar();
    calendar.initCalendar();
    initFeed();
    startVideoPlayer();

    // ga('create', analyticsUA.ge, 'auto'); // eslint-disable-line
  });
})(jQuery);

/* istanbul ignore if */
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// local_static/templates/especiais/verao_espetacular/assets/scripts/main.js